export function getApiBaseUrl(): string {
  // Local: prefer /api so Vite proxies to the Go API (same-origin, no CORS).
  // Prod admin image sets VITE_API_URL=/api; absolute URLs still work when CORS is enabled.
  const raw = import.meta.env.VITE_API_URL ?? '/api';
  return raw.replace(/\/$/, '');
}
